const rawBaseURL = process.env.REACT_APP_BACKEND_URL || '';
const baseURL = rawBaseURL.endsWith('/') ? rawBaseURL : `${rawBaseURL}/`;

export default baseURL;

export const endPoints = {
    okrBonuses: 'okr/bonuses',
    getVapiCalls: (params) => `vapi/calls?${params}`,
    getVapiCall: (id) => `vapi/calls/${encodeURIComponent(id)}`,
    //auth
    login: 'adminAuthentication/login',
    // password / OTP
    generateOtp: 'otp/generate',
    resendOtp: 'otp/resend',
    verifyOtp: 'otp/verify',
    changePassword: 'adminAuthentication/resetPassword',
    forcePasswordChange: 'adminAuthentication/forcePassword',

    //refresh token
    refreshToken: 'api/Admin/Login/refresh',

    //Permissions
    getallPermissions: 'api/Admin/Permission',

    //Merchant Payment Status
    updatePaymentStatus: 'api/Admin/Merchant/UpdatePaymentStatus',

    //Merchant Reports
    getMerchantReports: 'api/Admin/Reports/GetAllTransactions',

    //Dropdowns
    getRoleDropdown: 'roles',

    //users
    getallUsers: 'adminUser',
    addUser: 'adminUser',
    updateUser: 'adminUser',
    getUserById: (id) => `adminUser/${id}`,
    updateUserStatus: 'adminUser/updateStatus',
    deleteUser: (id) => `api/Admin/User/${id}`,
    getUserProfile: (id) => `adminUser/profile/${id}`,
    getAccessMatrix: 'adminUser/access-matrix',
    getAccessUsers: 'adminUser/access-users',
    getAccessAudit: 'adminUser/access-audit',
    updateUserAccess: (id) => `adminUser/access-users/${id}`,

    //teams
    getallteams: 'teams',
    updateTeam: (id) => `teams/${id}`,
    getTeamById: (id) => `teams/${id}`,
    getTeamMembersById: (id) => `teams/${id}/members`,

    //machine
    getallMachine: 'machine',
    addMachine: 'machine',
    machineWarehouse: (id) => `machine/${id}/warehouse`,
    machineWarehouseReservations: 'machine/warehouse',
    updateMachine: 'machine',
    assignMachineRoute: 'machine/assign-route',
    getMachineById: (id) => `machine/${id}`,
    deleteMachine: (id) => `machine/${id}`,
    reactivateMachine: (id) => `machine/${id}/reactivate`,

    //parts inventory
    getallPartsInventory: 'sparePart',
    addPartsInventory: 'sparePart',
    updatePartsInventory: 'sparePart',
    getPartsInventoryById: (id) => `sparePart/${id}`,
    deletePartsInventory: (id) => `sparePart/${id}`,
    getInventoryActivity: 'sparePart/activity',
    getSparePartRepairTasks: (params) => (params && params.length > 0 ? `sparePart/repair-tasks?${params}` : 'sparePart/repair-tasks'),
    getSparePartRepairTypes: 'sparePart/repair-tasks/types',
    createSparePartRepairTask: 'sparePart/repair-tasks',
    assignSparePartRepairTask: (id) => `sparePart/repair-tasks/${id}/assign`,
    startSparePartRepairTask: (id) => `sparePart/repair-tasks/${id}/start`,
    pauseSparePartRepairTask: (id) => `sparePart/repair-tasks/${id}/pause`,
    resumeSparePartRepairTask: (id) => `sparePart/repair-tasks/${id}/resume`,
    updateSparePartRepairTaskEvidence: (id) => `sparePart/repair-tasks/${id}/evidence`,
    completeSparePartRepairTask: (id) => `sparePart/repair-tasks/${id}/complete`,
    deleteSparePartRepairTask: (id) => `sparePart/repair-tasks/${id}`,

    //questions
    //level 1
    getAllLevel1Questions: 'levelOneQuestion',
    updateLevel1Question: (id) => `levelOneQuestion/${id}`,
    getLevel1QuestionById: (id) => `levelOneQuestion/${id}`,

    //level 2
    getAllLevel2Questions: (params) => `levelTwoQuestion?${params}`,
    addLevel2Question: 'levelTwoQuestion',
    updateLevel2Question: (id) => `levelTwoQuestion/${id}`,
    getLevel2QuestionById: (id) => `levelTwoQuestion/${id}`,
    updateStatusLevel2Question: 'levelTwoQuestion/activeInactive',

    //level 3
    getAllLevel3Questions: (params) => `levelThreeQuestion?${params}`,
    addLevel3Question: 'levelThreeQuestion',
    updateLevel3Question: (id) => `levelThreeQuestion/${id}`,
    getLevel3QuestionById: (id) => `levelThreeQuestion/${id}`,
    updateStatusLevel3Question: 'levelThreeQuestion/activeInactive',

    //complaints
    getallComplaints: (params) => `complaint?${params}`,
    getIncidentReport: (params) => `complaint/reports/incidents?${params}`,
    incidentAssessment: (id) => `complaint/reports/incidents/${id}/assessment`,
    incidentSalesImpact: (params) => `complaint/reports/incidents/sales-impact?${params}`,
    addComplaint: 'complaints',
    updateComplaint: (id) => `complaints/${id}`,
    getComplaintById: (id) => `complaint/${id}`,
    replyToComplaint: (id) => `complaint/${id}/reply`,
    deleteComplaint: (id) => `complaints/${id}`,
    updateComplaintStatus: 'complaint',
    updateComplaintCustomer: 'complaint/customer',
    updateComplaintTeam: 'complaint/team',
    sendComplaintToSupport: (id) => `complaint/${id}/send-to-support`,
    sendComplaintToTechnicians: (id) => `complaint/${id}/send-to-technicians`,
    createManualComplaint: 'complaint/manual',
    previewOpenComplaintPurge: (before) => `complaint/admin/open-before?before=${encodeURIComponent(before)}`,
    purgeOpenComplaints: 'complaint/admin/open-before',
    generateComplaintDraft: (id) => `complaint/${id}/draft`,
    recordComplaintDraftUsed: (id) => `complaint/${id}/draft/use`,
    takeOverComplaintAutomation: (id) => `complaint/${id}/automation/takeover`,
    releaseComplaintAutomation: (id) => `complaint/${id}/automation/release`,
    cancelComplaintAutomation: (id) => `complaint/${id}/automation/cancel`,
    resetComplaintAutomationBudget: (id) => `complaint/${id}/automation/reset-budget`,
    complaintAutomationSettings: 'complaint/automation/settings',
    toggleComplaintAutomation: 'complaint/automation/toggle',
    assignComplaintCashReturn: (id) => `complaint/${id}/cash-return/assign`,
    updateComplaintRefund: (id) => `complaint/${id}/refund`,
    sendComplaintRefundToFinance: (id) => `complaint/${id}/refund/send-to-finance`,
    financeComplaintRefundAction: (id) => `complaint/${id}/refund/finance-action`,
    rejectComplaintRefund: (id) => `complaint/${id}/refund/reject`,
    markComplaintRefundAlreadyProcessed: (id) => `complaint/${id}/refund/already-processed`,
    getRefundQueue: (params) => (params && params.length > 0 ? `complaint/refunds?${params}` : 'complaint/refunds'),
    exportRefundBatch: 'complaint/refunds/export',
    submitRefundBatch: (batchId) => `complaint/refunds/batch/${batchId}/submitted`,
    reopenRefundBatch: (batchId) => `complaint/refunds/batch/${batchId}/reopen`,
    approveRefundBatch: (batchId) => `complaint/refunds/batch/${batchId}/approve`,

    //repair orders
    getRepairOrders: (params) => (params && params.length > 0 ? `repairOrder?${params}` : 'repairOrder'),
    getMyRepairOrders: (params) => (params && params.length > 0 ? `repairOrder/my?${params}` : 'repairOrder/my'),
    getRepairOrdersByComplaint: (complaintId) => `repairOrder?complaintId=${complaintId}`,
    createRepairOrder: 'repairOrder',
    getRepairOrderById: (id) => `repairOrder/${id}`,
    closeRepairOrder: (id) => `repairOrder/${id}/close`,
    deleteRepairOrder: (id) => `repairOrder/${id}`,
    assignRepairTechnician: (id) => `repairOrder/${id}/assignTechnician`,
    addRepairOrderUsage: (id) => `repairOrder/${id}/addUsage`,
    weeklyRepairReport: (params) => `repairOrder/reports/weekly?${params}`,
    getFailuresList: (params) => (params && params.length > 0 ? `repairOrder/reports/failures?${params}` : 'repairOrder/reports/failures'),
    getTechnicianPerformance: (params) =>
        params && params.length > 0 ? `repairOrder/reports/technician-performance?${params}` : 'repairOrder/reports/technician-performance',

    // notifications
    getMyNotifications: (params) => (params && params.length > 0 ? `notification/my?${params}` : 'notification/my'),
    markNotificationRead: (id) => `notification/${id}/read`,
    markAllNotificationsRead: 'notification/read-all',

    //machine movement
    addMachineMovement: 'machineMovement',
    getMachineMovements: (params) => (params && params.length > 0 ? `machineMovement?${params}` : 'machineMovement'),
    getMachineMovement: (id) => `machineMovement/${id}`,
    updateMovementStatus: (id) => `machineMovement/${id}/updateStatus`,
    getMovementChecklist: (id) => `machineMovement/${id}/checklist`,
    updateMovementChecklist: (id) => `machineMovement/${id}/checklist`,
    deleteMachineMovement: (id) => `machineMovement/${id}`,
    getTechnicians: 'adminUser/technicians',

    //machine demonstrations
    getMachineDemonstrations: (params) => (params && params.length > 0 ? `machineDemonstration?${params}` : 'machineDemonstration'),
    createMachineDemonstration: 'machineDemonstration',
    getMachineDemonstration: (id) => `machineDemonstration/${id}`,
    updateMachineDemonstration: (id) => `machineDemonstration/${id}`,
    performMachineDemonstrationAction: (id) => `machineDemonstration/${id}/actions`,
    getSiteInspections: (params) => (params && params.length > 0 ? `siteInspection?${params}` : 'siteInspection'),
    createSiteInspection: 'siteInspection',
    getSiteInspection: (id) => `siteInspection/${id}`,
    updateSiteInspection: (id) => `siteInspection/${id}`,

    //maintenance / preventive maintenance
    addMaintenanceTask: 'maintenanceTask',
    getMaintenanceTasks: (params) => (params && params.length > 0 ? `maintenanceTask?${params}` : 'maintenanceTask'),
    getMaintenanceTask: (id) => `maintenanceTask/${id}`,
    completeMaintenanceTask: (id) => `maintenanceTask/${id}/complete`,
    deleteMaintenanceTask: (id) => `maintenanceTask/${id}`,

    //spare part usage
    getSparePartUsageByComplaint: (complaintId) => `sparePart/usage/byComplaint/${complaintId}`,
    getPendingSparePartUsageRequests: 'sparePart/usage/pending',
    getSparePartUsageReport: (params) => (params && params.length > 0 ? `sparePart/reports/usage?${params}` : 'sparePart/reports/usage'),
    requestSparePartUsage: 'sparePart/usage/request',
    approveSparePartUsage: 'sparePart/usage/approve',
    rejectSparePartUsage: 'sparePart/usage/reject',

    //dashboard
    getDashboardStats: (params) => (params && params.length > 0 ? `dashboard?${params}` : 'dashboard'),
    getCaseTracking: (params) => (params && params.length > 0 ? `dashboard/cases?${params}` : 'dashboard/cases'),
    getPerformanceReports: (params) => (params && params.length > 0 ? `dashboard/performance?${params}` : 'dashboard/performance'),

    //hr module
    hrCategories: 'hr/categories',
    hrRequests: 'hr/requests',
    updateHrRequest: (id) => `hr/requests/${id}`,
    hrFeedback: 'hr/feedback',
    updateHrFeedback: (id) => `hr/feedback/${id}`,
    hrEmployees: 'hr/employees',
    hrEmployeeProfile: (id) => `hr/employees/${id}/profile`,
    hrRoutingSettings: 'hr/settings/routing',
    updateHrRoutingSetting: 'hr/settings/routing',

    //analytics - complaints
    getRecurrentFailures: (params) =>
        params && params.length > 0 ? `complaint/reports/recurrentFailures?${params}` : 'complaint/reports/recurrentFailures',

    //parlevel
    parlevelDashboard: (params) => (params ? `parlevel/dashboard?${params}` : 'parlevel/dashboard'),
    parlevelTrends: (params) => (params ? `parlevel/trends?${params}` : 'parlevel/trends'),
    parlevelRouteTrends: (params) => (params ? `parlevel/route-trends?${params}` : 'parlevel/route-trends'),
    parlevelRouteNames: (params) => (params ? `parlevel/route-names?${params}` : 'parlevel/route-names'),
    parlevelStatus: 'parlevel/status',
    parlevelScrapeLogs: (params) => (params ? `parlevel/scrape-log?${params}` : 'parlevel/scrape-log'),
    parlevelRunMorning: 'parlevel/morning/run',
    parlevelRunNightly: 'parlevel/nightly/run',
    parlevelDailyRoutes: (params) => (params ? `parlevel/daily-routes?${params}` : 'parlevel/daily-routes'),
    parlevelRouteSales: (params) => (params ? `parlevel/route-sales?${params}` : 'parlevel/route-sales'),
    parlevelConsolidation: (params) => (params ? `parlevel/consolidation?${params}` : 'parlevel/consolidation'),
    parlevelMachineInventory: (params) => (params ? `parlevel/machine-inventory?${params}` : 'parlevel/machine-inventory'),
    parlevelChangeLevels: (params) => (params ? `parlevel/change-levels?${params}` : 'parlevel/change-levels'),
    parlevelChangeLevelsSummary: 'parlevel/change-levels/summary',
    parlevelChangeLevelRangeDashboard: (params) => (
        params
            ? `parlevel/change-levels/range-dashboard?${params}`
            : 'parlevel/change-levels/range-dashboard'
    ),
    parlevelChangeLevelHistory: (systemId, params) => (
        params
            ? `parlevel/change-levels/${systemId}/history?${params}`
            : `parlevel/change-levels/${systemId}/history`
    ),
    parlevelPostServiceObservations: (params) => (
        params
            ? `parlevel/change-levels/post-service-observations?${params}`
            : 'parlevel/change-levels/post-service-observations'
    ),
    parlevelChangeLevelObservations: (params) => (params ? `parlevel/change-levels/observations?${params}` : 'parlevel/change-levels/observations'),
    parlevelRunChangeLevels: 'parlevel/change-levels/run',
    parlevelPosSales: (params) => (params ? `parlevel/pos-sales?${params}` : 'parlevel/pos-sales'),
    parlevelCollectionStats: (params) => (params ? `parlevel/collection-stats?${params}` : 'parlevel/collection-stats'),
    parlevelBackfill: 'parlevel/backfill/run',
    parlevelReportRecipients: 'parlevel/report-recipients',
    parlevelTriggerReportEmail: 'parlevel/report-email/trigger',
    parlevelRouteProposals: (params) => (params ? `parlevel/route-proposals?${params}` : 'parlevel/route-proposals'),
    parlevelRouteProposal: (id) => `parlevel/route-proposals/${id}`,
    parlevelPlanningRoutes: (date) => 'parlevel/route-planning/routes?serviceDate=' + encodeURIComponent(date),
    parlevelRouteProposalGenerate: 'parlevel/route-proposals/generate',
    parlevelRouteProposalOrder: (id) => `parlevel/route-proposals/${id}/order`,
    parlevelRouteProposalReject: (id) => `parlevel/route-proposals/${id}/reject`,
    parlevelRouteProposalFinalize: (id) => `parlevel/route-proposals/${id}/finalize`,
    parlevelRouteProposalReconcile: (id) => `parlevel/route-proposals/${id}/reconcile`,
    parlevelRouteProposalHistory: (id) => `parlevel/route-proposals/${id}/history`,

    // jetinno (read-only)
    jetinnoSummary: 'jetinno/summary',
    jetinnoDevices: (params) => (params ? `jetinno/devices?${params}` : 'jetinno/devices'),
    jetinnoDevice: (machineNo) => `jetinno/devices/${encodeURIComponent(machineNo)}`,
    jetinnoTelemetrySummary: (params) => (params ? `jetinno/telemetry/summary?${params}` : 'jetinno/telemetry/summary'),
    jetinnoTelemetryDevices: (params) => (params ? `jetinno/telemetry/devices?${params}` : 'jetinno/telemetry/devices'),
    jetinnoTelemetryOrders: (params) => (params ? `jetinno/telemetry/orders?${params}` : 'jetinno/telemetry/orders'),
    jetinnoTelemetryOrder: (machineNo, orderNo) => `jetinno/telemetry/orders/${encodeURIComponent(machineNo)}/${encodeURIComponent(orderNo)}`,
    jetinnoTelemetryAlerts: (params) => (params ? `jetinno/telemetry/alerts?${params}` : 'jetinno/telemetry/alerts'),
    jetinnoTelemetrySupplies: (params) => (params ? `jetinno/telemetry/supplies?${params}` : 'jetinno/telemetry/supplies'),
    jetinnoTelemetryConsumption: (params) => (params ? `jetinno/telemetry/consumption?${params}` : 'jetinno/telemetry/consumption'),
    jetinnoAuthorizedMachines: 'jetinno/telemetry/authorized-machines',
    jetinnoAuthorizedMachine: (machineNo) => `jetinno/telemetry/authorized-machines/${encodeURIComponent(machineNo)}`,

    //operator dashboard
    operatorDashboardRoutes: 'operator-dashboard/routes',
    operatorDashboardOperators: 'operator-dashboard/operators',
    operatorDashboardSummary: (params) => (params && params.length > 0 ? `operator-dashboard/summary?${params}` : 'operator-dashboard/summary'),
    operatorDashboardAnomalyOverview: (params) => (params && params.length > 0 ? `operator-dashboard/anomaly-overview?${params}` : 'operator-dashboard/anomaly-overview'),
    operatorDashboardReturns: (params) => (params && params.length > 0 ? `operator-dashboard/returns?${params}` : 'operator-dashboard/returns'),
    completeOperatorDashboardProductReturn: (id) => `operator-dashboard/returns/${id}/complete-product`,
    returnOperatorDashboardProductToSupport: (id) => `operator-dashboard/returns/${id}/return-to-support`,
    operatorDashboardOkrContext: 'operator-dashboard/okr-context',
    operatorDashboardOkrWeekly: (params) => (params && params.length > 0 ? `operator-dashboard/okr-weekly?${params}` : 'operator-dashboard/okr-weekly'),
    operatorDashboardAnomalyReviews: (params) => (params && params.length > 0 ? `operator-dashboard/anomaly-reviews?${params}` : 'operator-dashboard/anomaly-reviews'),
    operatorDashboardPendingAnomalyReviews: 'operator-dashboard/anomaly-reviews/pending',
    operatorDashboardAnomalyReviewDraft: 'operator-dashboard/anomaly-reviews/draft',
    operatorDashboardAnomalyReviewCreateSubmit: 'operator-dashboard/anomaly-reviews/submit',
    operatorDashboardAnomalyReviewSubmit: (id) => `operator-dashboard/anomaly-reviews/${id}/submit`,
    operatorDashboardAnomalyReviewApprove: (id) => `operator-dashboard/anomaly-reviews/${id}/approve`,
    operatorDashboardAnomalyReviewReject: (id) => `operator-dashboard/anomaly-reviews/${id}/reject`,

    // quickbooks
    quickbooksConnect: (params) => (params && params.length > 0 ? `quickbooks/connect?${params}` : 'quickbooks/connect'),
    quickbooksAudit: 'quickbooks/audit',
    quickbooksStatus: (params) => (params && params.length > 0 ? `quickbooks/status?${params}` : 'quickbooks/status'),
    quickbooksCompanyInfo: (params) => (params && params.length > 0 ? `quickbooks/company-info?${params}` : 'quickbooks/company-info'),
    quickbooksCommercialDashboard: (params) =>
        params && params.length > 0 ? `quickbooks/commercial-dashboard?${params}` : 'quickbooks/commercial-dashboard',
    quickbooksFinancialIndicators: 'quickbooks/financial-indicators',
    quickbooksVendingReconciliation: (params) =>
        params && params.length > 0 ? `quickbooks/finance/vending-reconciliation?${params}` : 'quickbooks/finance/vending-reconciliation',
    quickbooksVendorBillPayments: (params) =>
        params && params.length > 0 ? `quickbooks/finance/vendor-bill-payments?${params}` : 'quickbooks/finance/vendor-bill-payments',
    quickbooksPayableBillAnnotation: 'quickbooks/finance/payable-bill-annotation',
    quickbooksReceivableInvoiceAnnotation: 'quickbooks/finance/receivable-invoice-annotation',
    quickbooksCommercialQuotas: (params) =>
        params && params.length > 0 ? `quickbooks/commercial-quotas?${params}` : 'quickbooks/commercial-quotas',
    quickbooksCommercialCustomerQuotas: (params) =>
        params && params.length > 0 ? `quickbooks/commercial-customer-quotas?${params}` : 'quickbooks/commercial-customer-quotas',
    quickbooksCommercialCustomerQuarterQuotas: (params) =>
        params && params.length > 0 ? `quickbooks/commercial-customer-quotas/quarter?${params}` : 'quickbooks/commercial-customer-quotas/quarter',
    quickbooksCommercialQuarterQuotas: (params) =>
        params && params.length > 0 ? `quickbooks/commercial-quotas/quarter?${params}` : 'quickbooks/commercial-quotas/quarter',
    quickbooksSyncSummary: (params) => (params && params.length > 0 ? `quickbooks/sync/summary?${params}` : 'quickbooks/sync/summary'),
    quickbooksSyncLogs: (params) => (params && params.length > 0 ? `quickbooks/sync/logs?${params}` : 'quickbooks/sync/logs'),
    quickbooksRunBusinessUnitSync: 'quickbooks/sync/business-unit',
    quickbooksRunEntitySync: (entityType) => `quickbooks/sync/${entityType}`,
    quickbooksEntities: (params) => (params && params.length > 0 ? `quickbooks/entities?${params}` : 'quickbooks/entities'),
    quickbooksDisconnect: (params) => (params && params.length > 0 ? `quickbooks/disconnect?${params}` : 'quickbooks/disconnect'),

    // revenue reconciliation (admin and superAdmin only)
    revenueReconciliationPeriods: 'revenue-reconciliation/periods',
    revenueReconciliationGenerate: (periodKey) => `revenue-reconciliation/periods/${periodKey}/generate`,
    revenueReconciliationPeriod: (periodId) => `revenue-reconciliation/periods/${periodId}`,
    revenueReconciliationItems: (periodId, params) =>
        params ? `revenue-reconciliation/periods/${periodId}/items?${params}` : `revenue-reconciliation/periods/${periodId}/items`,
    revenueReconciliationExport: (periodId) => `revenue-reconciliation/periods/${periodId}/export`,
    revenueReconciliationAdjustments: (periodId) => `revenue-reconciliation/periods/${periodId}/adjustments`,
    revenueReconciliationAdjustmentDecision: (adjustmentId) => `revenue-reconciliation/adjustments/${adjustmentId}/decision`,
    revenueReconciliationSubmit: (periodId) => `revenue-reconciliation/periods/${periodId}/submit`,
    revenueReconciliationClose: (periodId) => `revenue-reconciliation/periods/${periodId}/close`,
    revenueReconciliationReopen: (periodId) => `revenue-reconciliation/periods/${periodId}/reopen`,
    revenueReconciliationTrend: (months) => `revenue-reconciliation/trend?months=${months || 6}`,
    revenueReconciliationConfig: 'revenue-reconciliation/config',
    revenueReconciliationRefreshQuickBooksAccounts: 'revenue-reconciliation/config/refresh-quickbooks-accounts',
    revenueReconciliationBanescoPreview: 'revenue-reconciliation/sources/banesco/preview',
    revenueReconciliationBanescoImport: 'revenue-reconciliation/sources/banesco/import',
    revenueReconciliationBanescoPull: 'revenue-reconciliation/sources/banesco/pull',
    revenueReconciliationBanescoSource: (periodKey) =>
        `revenue-reconciliation/sources/banesco?periodKey=${encodeURIComponent(periodKey)}`,
    revenueReconciliationBanescoMapping: 'revenue-reconciliation/sources/banesco/mappings',
    revenueReconciliationBanescoCatalogPull: 'revenue-reconciliation/sources/banesco/catalog/pull',
    revenueReconciliationBanescoMappingSuggestions: (periodKey) =>
        `revenue-reconciliation/sources/banesco/mapping-suggestions?periodKey=${encodeURIComponent(periodKey)}`,
    revenueReconciliationBanescoMappingsBulk: 'revenue-reconciliation/sources/banesco/mappings/bulk',
    revenueReconciliationYappyPull: 'revenue-reconciliation/sources/yappy/pull',
    revenueReconciliationYappySource: (periodKey) =>
        `revenue-reconciliation/sources/yappy?periodKey=${encodeURIComponent(periodKey)}`,
    revenueReconciliationMappings: 'revenue-reconciliation/mappings',

    //okr
    okrCycles: 'okr/cycles',
    okrTeams: 'okr/teams',
    okrObjectives: 'okr/objectives',
    okrKeyResults: 'okr/key-results',
    okrKeyResultSyncWeek: (keyResultId) => `okr/key-results/${keyResultId}/sync-week`,
    okrWeeklyEntries: 'okr/weekly-entries',
    okrDashboard: 'okr/dashboard',
    okrScoreboard: 'okr/scoreboard'
};
